import { useTranslation } from 'react-i18next';
// @dynamic-i18n-keys
// Dynamic t() at line 20 (studio.reports.section.soldExclusives.types.${exclusiveType}):
//   studio.reports.section.soldExclusives.types.fixed_price
//   studio.reports.section.soldExclusives.types.offers
//   studio.reports.section.soldExclusives.types.resales
import ExclusiveTypeIcon, {
  ExclusiveType,
} from '../../../../SoldExclusivesSection/ExclusiveTypeIcon/ExclusiveTypeIcon';

import s from './SoldExclusivesTableRowHeadingMobile.scss';

interface Props {
  item: any;
}

export default function SoldExclusivesTableRowHeadingMobile({ item }: Props) {
  const exclusiveType = item.exclusiveType as ExclusiveType;
  const { t } = useTranslation();

  return (
    <div className={s['row-heading']}>
      <ExclusiveTypeIcon exclusiveType={exclusiveType} size={32} />
      <div className={s['type-label']}>
        {t(`studio.reports.section.soldExclusives.types.${exclusiveType}`)}
      </div>
    </div>
  );
}
